import React, { PureComponent } from "react";
import { translate } from "react-i18next";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import InputFormat from "../inputForm";
import CountryRegionData from "./data.json";
import settings from "./settings";
import DistrictVietnam from "./dist/quan_huyen.json";
class DistrictDropdown extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      regions: this.getRegions(props.country),
      districts: [],
    };
    this.getDistricts = this.getDistricts.bind(this);
    this.getRegions = this.getRegions.bind(this);
  }
  componentDidMount() {
    let listRegions = this.getRegions(this.props.country);
    let regionCode = this.getRegionCode(listRegions, this.props.region);

    this.setState({ districts: this.getDistricts(regionCode) });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.region !== this.props.region) {
      let listRegions = this.getRegions(nextProps.country);
      let regionCode = this.getRegionCode(listRegions, nextProps.region);
      this.setState({ districts: this.getDistricts(regionCode) });
    }
  }

  getDistricts(region = this.props.region) {
    const { country } = this.props;
    if (!region || country !== "VN") {
      return [];
    } else {
      let districts = [];
      districts = Object.values(DistrictVietnam).filter(
        (item) => item.parent_code === region
      );
      if (districts.length === 0) {
        return [];
      } else {
        return districts;
      }
    }
  }

  getRegions(country) {
    // Get list region/city by countryValue
    if (!country) {
      return [];
    }
    const { countryValueType } = this.props;
    const searchIndex =
      countryValueType === settings.DISPLAY_TYPE_FULL
        ? "countryName"
        : "countryShortCode";
    let regions = [];
    CountryRegionData.forEach((i) => {
      if (i[searchIndex] === country) {
        regions = i.regions;
      }
    });
    if (!regions || regions.length === 0) {
      console.error(
        "Error. Unknown country passed: " +
        country +
        '. If you\'re passing a country shortcode, be sure to include countryValueType="short" on the DistrictDropdown'
      );
      return [];
    }

    regions = regions.map((region) => {
      return { regionName: region.name, regionShortCode: region.shortCode };
    });
    return regions;
  }

  getRegionCode = (listRegions, regionValue) => {
    // Get region code of region value

    let res = listRegions.find(({ regionName, regionShortCode }) => {
      return regionName === regionValue || regionName.indexOf(regionValue) > -1;
    });

    if (res) return res.regionShortCode;
    return null;
  };

  getDistrictList() {
    let { districts = [] } = this.state;
    return districts.map((district, i) => {
      return (
        <MenuItem key={i} value={district.name}>
          {district.name}
        </MenuItem>
      );
    });
  }

  getDefaultOption() {
    const {
      blankOptionLabel,
      showDefaultOption,
      defaultOptionLabel,
      placeholder,
      country,
      region,
    } = this.props;
    if (!country && !region) {
      return (
        <MenuItem key="default" value=" ">
          {blankOptionLabel}
        </MenuItem>
      );
    }
    if (showDefaultOption) {
      return (
        <MenuItem key="default" value=" ">
          {defaultOptionLabel || placeholder}
        </MenuItem>
      );
    }
    return null;
  }

  render() {
    const {
      t,
      label,
      value,
      onChange,
      onBlur,
      id,
      name,
      disabled,
      classes,
      disable,
      InputLabelProps = {},
      SelectProps = {},
      ...arbitraryProps
    } = this.props;

    const attrs = {
      ...arbitraryProps,
      name,
      label,
      value,
      onChange: (e) => onChange(e),
      onBlur: (e) => onBlur(e),
      disabled: disabled,
    };
    if (id) {
      attrs.id = id;
    }
    if (classes) {
      attrs.className = classes;
    }

    return (
      <InputFormat
        {...attrs}
        select
        SelectProps={{
          displayEmpty: true,
          ...SelectProps,
        }}
        InputLabelProps={{
          ...InputLabelProps,
        }}
      >
        {this.getDefaultOption()}
        {this.getDistrictList()}
      </InputFormat>
    );
  }
}

const styles = (theme) => ({
  title: {
    fontSize: "1.5rem",
  },
  textField: {
    marginRight: theme.spacing(1),
    width: "100%",
  },
  input: {},
  label: {
    fontWeight: 410,
  },
});

DistrictDropdown.propTypes = {
  country: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  id: PropTypes.string,
  classes: PropTypes.object,
  blankOptionLabel: PropTypes.string,
  showDefaultOption: PropTypes.bool,
  defaultOptionLabel: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  labelType: PropTypes.string,
  valueType: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  disableUnderline: PropTypes.bool,
  customOptions: PropTypes.array,
};
DistrictDropdown.defaultProps = {
  country: "",
  value: "",
  name: "rcrs-region",
  id: "",
  classes: {},
  blankOptionLabel: "-",
  showDefaultOption: true,
  defaultOptionLabel: "Select District",
  onChange: () => { },
  onBlur: () => { },
  countryValueType: settings.DISPLAY_TYPE_FULL,
  regionvaluetype: settings.DISPLAY_TYPE_FULL, // warning react : regionValueType => regionvaluetype
  labelType: settings.DISPLAY_TYPE_FULL,
  valueType: settings.DISPLAY_TYPE_FULL,
  disabled: false,
  customOptions: [],
};

const mapState = (state) => ({
  districtstate: state.district,
});

const mapDispatch = (dispatch) => ({});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(DistrictDropdown)
  )
);
